import { useState, useEffect, useRef } from "react";
import { BiCheckbox } from "react-icons/bi";
import { FaBars, FaTimes } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

function DLAFellowshipPublic() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const headerRef = useRef(null);

  const api = axios.create({
    baseURL: "https://backend.dlapakistan.com",
    timeout: 5000,
  });

  const fetchContent = async () => {
    try {
      setLoading(true);
      const response = await api.get("/api/dla-fellowship/");
      
      console.log("Public GET Response:", response.data);
      
      if (response.data && response.data.success && response.data.data) {
        setContent(response.data.data);
      } else {
        console.log("No content found");
      }
    } catch (error) {
      console.error("Error fetching content:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContent();
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobileView = windowWidth <= 1029;

  const sidebarLinks = [
    { text: "About Us", border: "#ccc", showIcon: false, path: "/about" },
    { text: "Meet the Board", border: "#ccc", showIcon: true, path: "/about/meet-the-board" },
    { text: "Work We Do", border: null, showIcon: true, path: "/about/work-we-do" },
    { text: "Education", border: null, showIcon: false, path: "/about/work-we-do/education" },
    { text: "Regulation", border: null, showIcon: false, path: "/about/work-we-do/regulation" },
    { text: "Membership Support", border: "#ccc", showIcon: false, path: "/about/work-we-do/membership-support" },
    { text: "Our Policies", border: "#ccc", showIcon: true, path: "/about/our-policies" },
    { text: "Become a Member", border: "#ccc", showIcon: true, path: "/about/become-member" },
    { text: "DLA Fellowship", border: null, showIcon: true, path: "/about/dla-fellowship" },
    { text: "DLA Fellowship Awards", border: null, showIcon: false, path: "/about/dla-fellowship/awards" },
    { text: "DLA Special Recognition Award", border: "#ccc", showIcon: false, path: "/about/dla-fellowship/special-recognition" },
  ];

  const handleSidebarClick = (path) => {
    navigate(path);
    if (isMobileView) setIsSidebarOpen(false);
  };

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const handleBreadcrumbClick = (path) => {
    navigate(path);
  };

  if (loading) {
    return (
      <div className="w-full min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#70B444]"></div>
      </div>
    );
  }

  return (
    <div className="w-full min-h-screen" ref={headerRef}>
      <div className="w-full px-4 mt-52 sm:px-6 md:px-8 lg:px-10 xl:px-12 mx-auto">
        
        <div className="flex flex-wrap items-center text-gray-500 mb-6 text-sm md:text-base">
          <span className="cursor-pointer hover:underline hover:text-[#70B444]" onClick={() => handleBreadcrumbClick("/")}>Home</span>
          <span className="mx-2">»</span>
          <span className="cursor-pointer hover:underline hover:text-[#70B444]" onClick={() => handleBreadcrumbClick("/about")}>About The DLA</span>
          <span className="mx-2">»</span>
          <span className="text-[#70B444] font-medium">DLA Fellowship</span>
        </div>

        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 relative pb-8 md:pb-12">
          
          {!isMobileView && (
            <div className="w-full lg:w-72 xl:w-80 shrink-0 bg-[#f7f9fc] p-4 md:p-5 rounded-lg shadow-sm h-fit sticky top-24">
              <div className="bg-[#70B444] text-white p-3 text-center mb-4">
                <h3 className="m-0 text-base lg:text-lg font-semibold">About The DLA</h3>
              </div>
              {sidebarLinks.map((item, index) => (
                <div
                  key={index}
                  onClick={() => handleSidebarClick(item.path)}
                  className={`flex items-center py-2.5 text-[#70B444] font-medium cursor-pointer transition-all hover:bg-[rgba(112,180,68,0.1)] px-2 text-sm lg:text-base ${
                    item.border ? "border-b border-gray-200" : ""
                  } ${location.pathname === item.path ? "bg-[rgba(112,180,68,0.1)] border-l-4 border-l-[#70B444]" : ""}`}
                >
                  {item.showIcon && <BiCheckbox className="mr-2 text-lg flex-shrink-0" />}
                  <span className="break-words">{item.text}</span>
                </div>
              ))}
            </div>
          )}

          <div className="flex-1">
            <div className="flex justify-between items-center border-b-2 border-[#70B444] pb-3 md:pb-4 mb-4 md:mb-6">
              <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-[#70B444]">
                {content?.title || "DLA Fellowship"}
              </h1>
              {isMobileView && (
                <button onClick={toggleSidebar} className="flex items-center gap-2 text-[#70B444] border border-[#70B444] rounded px-3 py-2">
                  {isSidebarOpen ? <FaTimes /> : <FaBars />} <span>Menu</span>
                </button>
              )}
            </div>

            <div className="space-y-4 md:space-y-6 text-gray-700">
              {content?.subtitle && (
                <h3 className="font-bold text-gray-800 text-lg md:text-xl">{content.subtitle}</h3>
              )}
              
              <div
                className="custom-content-view"
                dangerouslySetInnerHTML={{ __html: content?.description || "" }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Sidebar */}
      {isMobileView && (
        <>
          <div
            className={`fixed top-0 right-0 h-full w-[85vw] max-w-sm bg-white z-[60] shadow-2xl transform transition-transform duration-300 ease-in-out ${
              isSidebarOpen ? "translate-x-0" : "translate-x-full"
            }`}
          >
            <div className="flex flex-col h-full">
              <div className="p-4 border-b flex justify-between items-center bg-[#70B444] text-white">
                <span className="font-bold text-lg">About The DLA</span>
                <FaTimes 
                  className="cursor-pointer text-2xl" 
                  onClick={toggleSidebar} 
                />
              </div>
              <div className="overflow-y-auto flex-1 p-2">
                {sidebarLinks.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => handleSidebarClick(item.path)}
                    className={`p-3 md:p-4 text-base border-b border-gray-100 flex items-center hover:bg-gray-50 ${
                      location.pathname === item.path 
                        ? "text-[#70B444] font-semibold bg-green-50 border-l-4 border-l-[#70B444]" 
                        : "text-gray-700"
                    }`}
                  >
                    {item.showIcon && <BiCheckbox className="mr-3 text-xl text-[#70B444] flex-shrink-0" />}
                    <span>{item.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Overlay */}
          {isMobileView && isSidebarOpen && (
            <div
              className="fixed inset-0 bg-black/50 z-[50] transition-opacity"
              onClick={toggleSidebar}
            />
          )}
        </>
      )}

      <style jsx>{`
        .custom-content-view {
          background-color: transparent !important;
        }
        
        .custom-content-view :global(*) {
          background-color: transparent !important;
          background: transparent !important;
        }

        .custom-content-view :global(p) {
          margin-bottom: 1.25rem;
          line-height: 1.75;
        }

        .custom-content-view :global(ul), .custom-content-view :global(ol) {
          margin-bottom: 1.5rem;
          padding-left: 2rem;
        }

        .custom-content-view :global(li) {
          margin-bottom: 0.5rem;
        }
      `}</style>
    </div>
  );
}

export default DLAFellowshipPublic;